module.exports = __webpack_public_path__ + "salt-7a0cb861f7c1af9e3a1af15547edf1cf.svg";